import { Injectable } from '@angular/core';
import { GlobalService } from './global.service';
import * as moment from 'moment';

@Injectable()
export class UtilService {

    constructor(private _gs: GlobalService) { }

    public getMoment(longDate, format) {
        return moment(longDate).format(format);
    }

    public getCurrentDateTime(format) {
        return moment().format(format);
    }

    public hasPermission(requiredPermissions: string[]): boolean {
        let returnVar = true
        requiredPermissions.forEach(item => {
            if (this._gs.currentUser.permissions.indexOf(item) < 0) {
                returnVar = false
            }
        });
        return returnVar;
    }
    public getId(currentId): boolean {
        if (currentId != null && typeof currentId != undefined) {
            return true;
        }
        else {
            return false;
        }
    }
    formatDocType(docType?: string) {
        if (docType) {
            // .split(' ').join('')
            // docType = docType.replace("_", " ");
            // docType = docType.replace("_", " ");
            // return docType.replace("_", " ");
            docType = docType.split('_').join(' ');
            return docType;
        }

        else
            return null
    }
    formatNull(docType?: string) {
        if (docType)
            return docType.replace("null", " ");
        else
            return null
    }
    formatDate(date: Date) {
        if (date)
            return moment(date).format('DD/MM/YYYY, hh:mm: a');
        else
            return null
    }

    isNothing(obj) {
        if (obj === undefined || obj === null || obj === '') {
            return true;
        }
        else {
            return false;
        }
    }

    toTitleCase(str: string) {
        str = str + " "
        let string = str.toLowerCase().replace(/[^A-Za-z0-9]/g, ' ')
            .split(' ')
            .reduce((result, word) => result + " " + word.charAt(0).toUpperCase() + word.toLowerCase().slice(1))
        return string.charAt(0).toUpperCase() + string.toLowerCase().slice(1);
    }

    inputTrimSpace() {

    }
    formatTwoDecimal(input: number) {
        return input.toFixed(2);
    }
}


// WEBPACK FOOTER //
// ./src/app/_global/util.service.ts